import Service from './Service';
import { SERVER_URL } from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class ServiceSubcategoryService extends Service {
    constructor() {
        super();
        this.baseURL = 'serviceSubcategory';
    }

    findIncidentSubCategories(serviceCategoryId) {
        let URL = SERVER_URL + this.baseURL + '/findIncidentSubCategories/' + (serviceCategoryId === undefined ? '' : serviceCategoryId);
        return fetch(URL, {
            headers: { 'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization") }
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findServiceRequestSubCategories(serviceCategoryId) {
        let URL = SERVER_URL + this.baseURL + '/findServiceRequestSubCategories/' + (serviceCategoryId === undefined ? '' : serviceCategoryId);
        return fetch(URL, {
            headers: { 'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization") }
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findByCategoryId(serviceCategoryId) {
        return fetch(SERVER_URL + this.baseURL + '/' + serviceCategoryId, {
            headers: { 'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization") }
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findAllOrderByStatus() {
        return fetch(SERVER_URL + this.baseURL, {
            headers: { 'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization") },
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}